const Login = require("./containers/Login");

module.exports = {
    path: "/login",
    component: Login,
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/login/index.js